import useDocumentTitle from '../hooks/useDocument';
import {Link} from 'react-router-dom';
import Header from '../components/header';
import Breadcrumb from '../components/breadcrumb';
import Features from '../components/features';
import CallToAction from '../components/calltoaction';
import Footer from '../components/footer';

function NursingView() {
  useDocumentTitle('Nursing care-Quality-Home-Healthcare');
  return (
    <div className="body-wrapper">
      <Header />
      <Breadcrumb image={'bg-image-21'} title={'Nursing Care'} />

      <div className="ltn__page-details-area ltn__service-details-area mb-105">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <h2 className="text-left compassion">
                Home care tailored to your needs
              </h2>
              <div className="ltn__page-details-inner ltn__service-details-inner">
                <p className="values_p">
                  {' '}
                  <span className="ltn__first-letter">W</span>here you have
                  complex needs and need clinical care, we can provide
                  specialist registered nurses to support your person-centered
                  care package in your home.
                </p>
                <p className="values_p3">
                  A package delivered by nurses gives room for clinical
                  decisions to be made according to the continuous and changing
                  needs of the care that you receive.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <aside className="sidebar-area ltn__right-sidebar">
                <h2 className="text-center compassion">Also see:</h2>
                <div className="widget-2 ltn__menu-widget ltn__menu-widget-2 text-uppercase">
                  <ul>
                    <li>
                      <Link to="/our-care">
                        Our care
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li className="">
                      <Link to="/our-values">
                        Our values
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/learning-disability">
                        Learning Disability
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>
      <div className="call-to-action-area call-to-action-5  bg-overlay-theme-90 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">
                  Creating your bespoke package of care
                </h2>
                <p className="white-color">
                  if necessary, we will collaborate with you, your family, and
                  multidisciplinary teams to design a customized package of care
                  that will address your clinical, social, and personal needs.
                </p>
                <p className="white-color">
                  At the beginning of your journey, we frequently collaborate
                  closely with acute settings and brain rehabilitation units to
                  ease your transition home. Along with the practical and
                  clinical aspects of your care, we take into account the social
                  and emotional aspects of your everyday life.
                </p>
                <p className="white-color">
                  We have a wealth of expertise providing care for people with
                  brain injuries, which has prepared us to assist our clients
                  and their families during a period that can be incredibly
                  difficult.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="compassion">The way we support you</h2>
                <p>
                  The type of care our registered nurses provide for you at home
                  includes:
                </p>
                <div>
                  <ul className="care_bullets-2">
                    <li>
                      Developing a personalized care plan that our Nurses can
                      work with and update in relation to your changing needs or
                      requirements.
                    </li>
                    <li className="">
                      Supporting with the initial discharge from a hospital or
                      rehabilitation unit.
                    </li>
                    <li>Supporting multiple and complex clinical needs.</li>
                    <li>
                      Helping you develop confidence towards greater
                      independence and involvement within the local community.
                    </li>
                    <li>Assisting you with any health needs if necessary..</li>
                    <li>
                      Providing respite and additional support to your family.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 compassion-bg pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">HPN and IV Therapies</h2>
                <p className="white-color">
                  The number of children and adults undergoing home enteral tube
                  feeding (IV) and home parenteral nutrition (HPN) is steadily
                  rising. Intravenous feeding and hydration are provided by home
                  parenteral nutrition .
                </p>
                <p className="white-color">
                  When nutritional and/or water and electrolyte balance cannot
                  be restored by oral or enteral feeding and the service user
                  has acute or chronic intestinal failure, HPN is required.
                </p>
                <p className="white-color">
                  HPN is possible at home. (Messing B et al in Intestinal
                  Failure 2001). As part of the care plans that are provided by
                  our registered nurses, we are able to administer intravenous
                  (IV) therapies and home parenteral nutrit
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="compassion">Getting you home</h2>
                <p className="">
                  Our registered nurses can provide hands-on care to help you
                  when a prompt hospital discharge is necessary.
                </p>
                <p>
                  We can continue to provide healthcare assistants to cater for
                  your personal, clinical, and social care needs once you are
                  back in the comfort of your own home, if necessary. To
                  guarantee that you receive the greatest caliber of
                  individualized care, our registered nurses will collaborate
                  with the rest of the care team.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left"></div>
            </div>
          </div>
        </div>
      </div>
      <Features
        icon1="fas fa-chevron-right"
        icon2="fas fa-volume-up"
        text1=" Combining skills, expertise and knowledge to offer quality
                  care."
        text2="Read what our customers have to say about us.
        "
        link1="/team"
        link2="/testimonials"
        btn1="Meet our team"
        btn2="Read our testimonials"
      />
      <CallToAction />
      <Footer />
    </div>
  );
}

export default NursingView;
